<div class="topbar-clock" aria-label="Horario atual">
  <i class="pi pi-clock"></i>
  <span class="topbar-clock__time">{{ timeLabel() }}</span>
  <span class="topbar-clock__date">{{ dateLabel() }}</span>
</div>
